module.exports = __webpack_public_path__ + "static/team-thomas-uta-avatar-192px-7f1cb111f93b519f8bb87eca2db3476e.jpg";